<template>
  <div class="ism-page">
    <div class="ism-page-header">
      <div class="ism-page-title">
        <h2>System Settings</h2>
        <p class="text-caption text-muted mb-0">Manage global configurations</p>
      </div>
    </div>

    <v-card class="ism-card mt-4" elevation="0">
      <v-card-title class="px-6 py-4 border-bottom">
        Payment Gateway Settings
      </v-card-title>
      <v-card-text class="pa-6">
          <div class="mb-2 text-subtitle-2 font-weight-medium text-primary">
            Online Payment Charge (%)
          </div>
          <p class="text-caption text-muted mb-4">
            This percentage will be calculated and added to the member's final payable amount when they choose to pay online.
          </p>

          <div style="width: 100%; max-width: 400px;">
            <PremiumInput
              v-model="chargePercentage"
              type="number"
              placeholder="e.g. 2.5"
              :error="chargeError"
              @input="chargeError = ''"
            />
          </div>
      </v-card-text>
      <v-card-actions class="pa-6 pt-0 d-flex justify-start ">
        <v-btn
          color="primary"
          class="text-none font-weight-medium px-6"
          elevation="0"
          :loading="saving"
          @click="saveSettings"
        >
          Save Changes
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import PremiumInput from '../common/PremiumInput.vue';

export default {
  name: "Settings",
  components: { PremiumInput },
  data() {
    return {
      saving: false,
      loading: false,
      chargePercentage: '',
      chargeError: '',
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    ...mapMutations('alert', ['setAlert']),

    async fetchSettings() {
      this.loading = true;
      try {
        const res = await this.$axios.get("/superadmin/settings");
        if (res.data.status && res.data.data) {
          this.chargePercentage = res.data.data.payment_gateway_charge_percentage;
        }
      } catch (error) {
        this.setAlert({ showAlert: true, message: "Failed to load settings.", variant: "red accent-3", timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    async saveSettings() {
      // Frontend validation
      this.chargeError = '';
      if (this.chargePercentage === '' || this.chargePercentage === null) {
        this.chargeError = 'Percentage is required.';
        return;
      }
      if (Number(this.chargePercentage) < 0) {
        this.chargeError = 'Cannot be negative.';
        return;
      }
      if (Number(this.chargePercentage) > 100) {
        this.chargeError = 'Cannot exceed 100%.';
        return;
      }

      this.saving = true;
      try {
        const payload = {
          payment_gateway_charge_percentage: Number(this.chargePercentage)
        };
        const res = await this.$axios.post("/superadmin/settings", payload);
        if (res.data.status) {
          this.setAlert({ showAlert: true, message: "Settings saved successfully.", variant: "green accent-4", timeout: 3000 });
        } else {
          this.setAlert({ showAlert: true, message: res.data.message || "Failed to save settings.", variant: "red accent-3", timeout: 3000 });
        }
      } catch (error) {
        this.setAlert({ showAlert: true, message: "Something went wrong.", variant: "red accent-3", timeout: 3000 });
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid var(--border-color, #e0e0e0) !important;
}

</style>
